import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()(() => {
    return {
        options: {
            width: 200,
        },
    }
})

export default useStyles
